import get from 'lodash/get';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withHandlers from 'recompose/withHandlers';
import {formDataManager} from 'hoc/formDataManager';
import ChangePasswordModal from './ChangePasswordModal';
import config from './changePasswordFormConfig';
import {submitChangePasswordAction, endChangePasswordAction} from '../../../actions';

const mapStateToProps = state => {
  const {changingPassword, changePasswordSubmitted, currentUserId, currentUser} = state.userManagement;
  return {
    userId: currentUserId,
    email: get(currentUser, 'email', null),
    modalOpen: changingPassword,
    changingPassword: changePasswordSubmitted
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  changePassword: submitChangePasswordAction,
  handleClose: endChangePasswordAction
}, dispatch);

const ChangePasswordModalContainer = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onSaveData: props => data => props.changePassword(Number(props.userId), data.newPassword, data.newPasswordConfirm)
  }),
  formDataManager({newPassword: '', newPasswordConfirm: ''}, config),
  lifecycle({
    componentWillReceiveProps(nextProps) {
      const modalWillClose = this.props.modalOpen && !nextProps.modalOpen;
      if (modalWillClose) {
        this.props.reset();
      }
    }
  })
)(ChangePasswordModal);

export default ChangePasswordModalContainer;



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/modals/ChangePasswordModal/ChangePasswordModalContainer.js